<div class="p-d-flex d-md-flex d-none d-md-none club-navigation-sticky">
    <div>
        <nav class="card club-navigation-component p-ml-3 p-my-3" tourAnchor="clubs">
            <div class="club-scroll-container">
                <button *ngIf="showScrollUp" class="scroll-arrow up" (click)="scrollList(-1)" aria-label="Scroll up">
                    <span class="pi pi-angle-up"></span>
                </button>

                <ng-container *ngIf="!isLoading && (clubsStore.member$ | async) as clubMember; else fullLoading">
                    <ul #clubList class="club-list" (scroll)="onScroll()">
                        <li class="club-item" [pTooltip]="'clubs.navigation.browseClubs' | translate">
                            <a class="explore-clubs" [routerLink]="['/clubs']">
                                <div class="label">
                                    <i class="pi pi-search"></i>
                                </div>
                            </a>
                        </li>

                        <li
                            *ngFor="let club of clubsToDisplay"
                            class="club-item-li"
                            [pTooltip]="club?.title"
                            [class.active]="club?.id === clubsStore?.displayedClub?.id"
                        >
                            <div class="club-item">
                                <a class="select-club" [routerLink]="['/clubs', club.id]" style="position: relative">
                                    <img
                                        *ngIf="club.profilePictureUrl; else textLabel"
                                        [src]="club.profilePictureUrl"
                                        alt="profile"
                                        routerLinkActive="active"
                                        [ngClass]="{
                                            'club-item-li-not-selected': isOnClubRoute && selectedClubId !== club?.id
                                        }"
                                    />
                                    <p-badge
                                        *ngIf="clubActivityService.newActivityCountByClubId(club.id, true) > 0"
                                        [value]="clubActivityService.newActivityCountByClubId(club.id, true)"
                                        severity="danger"
                                        class="club-new-activity-badge"
                                    ></p-badge>
                                    <p-badge
                                        *ngIf="
                                            !clubActivityService.newActivityCountByClubId(club.id, true) &&
                                            clubActivityService.isNewClub(club.id, false)
                                        "
                                        [value]="'clubs.navigation.newClubBadge' | translate"
                                        severity="danger"
                                        class="club-new-activity-badge"
                                    ></p-badge>

                                    <ng-template #textLabel>
                                        <div
                                            class="p-d-flex"
                                            [style]="{ width: '100%' }"
                                            [ngClass]="{
                                                'club-item-li-not-selected': isOnClubRoute && selectedClubId !== club?.id
                                            }"
                                        >
                                            <div class="p-m-auto" [style]="{ color: 'var(--white)' }">
                                                {{ club?.title.slice(0, 2) }}
                                            </div>
                                        </div>
                                    </ng-template>
                                </a>
                            </div>
                        </li>

                        <li *ngIf="canCreateClub || isCommunityManager" class="club-item" [pTooltip]="'clubs.navigation.createClub' | translate">
                            <create-club-modal-button class="add-club" [club]="null"></create-club-modal-button>
                        </li>
                    </ul>

                    <button *ngIf="showScrollDown" class="scroll-arrow down" (click)="scrollList(1)" aria-label="Scroll down">
                        <span class="pi pi-angle-down fs-4"></span>
                    </button>
                </ng-container>
            </div>
        </nav>

        <ng-template #fullLoading>
            <div class="loading-container">
                <wudo-spinner></wudo-spinner>
            </div>
        </ng-template>
    </div>

    <div *ngIf="isOnClubRoute">
        <room-navigation
            *ngIf="clubsStore.displayedClub$ | async as club"
            class="room-navigation"
            [rooms]="clubsStore.displayRooms"
            [displayClubTitle]="getClubTitle()"
            [displayedClub]="getClub()"
        ></room-navigation>
    </div>
</div>
